module.exports = __webpack_public_path__ + "static/media/ic-good-give.d3f6809f.svg";